import { electricityEU, fuels } from "../components/carbon-assesments/fuel/FuelFactors";

const conditions = {
  'Tropical Montane': 'uknown',
  'Tropical Wet': 'wet',
  'Tropical Moist': 'wet',
  'Tropical Dry': 'dry',
  'Warm Temperate Moist': 'wet',
  'Warm Temperate Dry': 'dry',
  'Cool Temperate Moist': 'wet',
  'Cool Temperate Dry': 'dry',
  'Boreal Moist': 'wet',
  'Boreal Dry': 'dry',
  'Polar Moist': 'wet',
  'Polar Dry': 'dry',
}

export const pesticideTypes = {
  "I&N": 'Insecticide & Nematicide',
  "H": 'Herbicide',
  "F": 'Fungicide',
  "H&D": 'Herbicide & Desiccant',
  "GR": 'Growth Regulator',
  "Insecticide": 'Insecticide',
  "F FST": 'Fungicide Seed Treatment',
  "I&A&N": 'Insecticide, Adjuvant & Nematicide',
  "F FST,FST": 'Fungicide & Fungicide Seed Treatment',
  "S,F": 'Seed Treatment, Fungicide',
  "SA": 'Seed Treatment, Adjuvant',
  "H&D,H": 'Herbicide & Desiccant, Herbicide',
  "I&N,M&R": 'Insecticide & Nematicide, Molluscide',
  "I&N,I": 'Insecticide & Nematicide, Insecticide',
}


export const animalsMassAndNexcretion = {
  "Dairy cattle": { name: 'Dairy cattle', rate: 0.54, mass: 600, efef: 126 },
  "Other cattle": { name: 'Other cattle', rate: 0.42, mass: 405, efef: 52 },
  "Buffalo": { name: 'Buffalo', rate: 0.45, mass: 509, efef: 78 },
  "Pigs": { name: 'Pigs', rate: 0.65, mass: 76, efef: 1.25 },
  "Sheep": { name: 'Sheep', rate: 0.36, mass: 40, efef: 7 },
  "Goats": { name: 'Goats', rate: 0.46, mass: 40, efef: 7 },
  "Horses": { name: 'Horses', rate: 0.26, mass: 377, efef: 18 },
  "Mules": { name: 'Mules', rate: 0.26, mass: 130, efef: 10 },
  "Donkeys": { name: 'Donkeys', rate: 0.26, mass: 130, efef: 10 },
  "Camels": { name: 'Camels', rate: 0.38, mass: 217, efef: 46 },
  "Ostrich": { name: 'Ostrich', rate: 0.36, mass: 120, efef: 5 },
  "Deer": { name: 'Deer', rate: 0.67, mass: 120, efef: 20 },
  "Reindeer": { name: 'Reindeer', rate: 0.23, mass: 120, efef: 20 },
}

//MJ/kg
export const energyContentFuels = {
  'Wood': {energyContent: 16, ef: 0.06020603749999999, fuel: 'Wood'},
  'Coal': {energyContent: 24, ef: 2.7, fuel: 'Coal'},
  'Bioethanol': {energyContent: 26.8, ef: 0.00901, fuel: 'Bioethanol'},
  'Biodiesel': {energyContent: 38, ef: 0.00521, fuel: 'Biodiesel'},
  // 'Crude oil': {energyContent: 44, ef: 0},
  'Diesel': {energyContent: 45, ef: 2.6, fuel: 'Diesel'},
  'Gasoline': {energyContent: 46, ef: 2.2, fuel: 'Gasoline'},
  'Natural gas': {energyContent: 55, ef: 1.55709, fuel: 'Natural gas'},
}



class $carbon {

  factors = (climateZone) => ({
    residues: {
      efCH4: 0.0027,
      efN2O: 0.00007,
      FRACleach: climateZone === 'wet' ? 0.24 : 0,
      GWPN2O: 273,
      GWPCH4: 27.9,
      EF1: climateZone === 'wet' ? 0.006 : 0.005,
      EF5: climateZone === 'wet' ? 0.011 : 0,
    },
    pesticides: {
      conversionMJtoCO2: 0.069
    },
    animals: {
      LF: climateZone === 'wet' ? 0.24 : 0,
      EF3: climateZone === 'wet' ? 0.006 : 0.002,
      EF4: climateZone === 'wet' ? 0.014 : 0.005,
      EF5: climateZone === 'wet' ? 0.011 : 0,
      Fvol: 0.21,
      GWPN2O: 273,
    },
    soil: {
      EFmin: 0.01,
      LF: climateZone === 'wet' ? 0.24 : 0,
      EFLeach: 0.011,
      GWPN2O: 273,
    },
    fertilisers: {
      GWPN2O: 273,
      LF: climateZone === 'wet' ? 0.24 : 0,
      EFLeach: 0.011,
      EFvol: climateZone === 'wet' ? 0.014 : 0.005,
      EFurea: 0.2,
      EFlime: 0.12,
      products: {
        'Ammonia': { name: 'Ammonia', efp: 1.910, efd: 0.010, frac: 0.11 },
        'Nitric acid': { name: 'Nitric acid', efp: 1.980, efd: 0.010, frac: 0.11 },
        'Amounium Nitrate': { name: 'Amounium Nitrate', efp: 2.280, efd: 0.010, frac: 0.11 },
        'Calcium Ammonium Nitrate': { name: 'Calcium Ammonium Nitrate', efp: 1.820, efd: 0.010, frac: 0.11 },
        'Urea': { name: 'Urea', efp: 0.610, efd: 0.010, frac: 0.11 },
        'Urea Ammonium Nitrate': { name: 'Urea Ammonium Nitrate', efp: 1.310, efd: 0.010, frac: 0.11 },
        'Single Superphosphate': { name: 'Single Superphosphate', efp: 0.002, efd: 0.010, frac: 0.11 },
        'Triple Superphosphate': { name: 'Triple Superphosphate', efp: 0.170, efd: 0.010, frac: 0.11 },
        'Monoammonium Phosphate': { name: 'Monoammonium Phosphate', efp: 0.310, efd: 0.010, frac: 0.11 },
        'Diamonium Phosphate': { name: 'Diamonium Phosphate', efp: 0.460, efd: 0.010, frac: 0.11 },
        'NPK (Acid)': { name: 'NPK (Acid)', efp: 0.970, efd: 0.010, frac: 0.11 },
        'NPK (Nitro)': { name: 'NPK (Nitro)', efp: 0.830, efd: 0.010, frac: 0.11 },
        'NPK (Mix)': { name: 'NPK (Mix)', efp: 0.340, efd: 0.010, frac: 0.11 },
        'Manure - Cattle': { name: 'Manure - Cattle', efp: 0, efd: 0.004, frac: 0.21 },
        'Manure - Sheep and other animals': { name: 'Manure - Sheep and other animals', efp: 0, efd: 0.003, frac: 0.21 },
      }
    },
    irrigation: {
      factors: {
        'Electricity': { name: 'Electricity', type: 'Electricity', ef: electricityEU },
        "Biodiesel ME (from used cooking oil)": { name: "Biodiesel ME (from used cooking oil)", type: "Diesel", unit: "litre(s)", ef: 0.16751 },
        "Biodiesel ME (from tallow)": { name: "Biodiesel ME (from tallow)", type: "Diesel", unit: "litre(s)", ef: 0.03558 },
        "Biodiesel HVO": { name: "Biodiesel HVO", type: "Diesel", unit: "litre(s)", ef: 0.00214 },
        "Biodiesel ME": { name: "Biodiesel ME", type: "Diesel", unit: "litre(s)", ef: 0.00521 },
        "Diesel (average biofuel blend)": { name: "Diesel (average biofuel blend)", type: "Diesel", unit: "litre(s)", ef: 2.51233 },
        "Diesel (100% mineral diesel)": { name: "Diesel (100% mineral diesel)", type: "Diesel", unit: "litre(s)", ef: 2.70553 },
      },
      ef: 72,
      methods: {
        'Sprinkler': { name: 'Sprinkler', energyUse: 0.5, 'Electricity': 3.5, 'Diesel': 3.7 },
        'Flooding': { name: 'Flooding', energyUse: 0.139, 'Electricity': 1.6, 'Diesel': 1.7 },
        'Drip irrigation': { name: 'Drip irrigation', energyUse: 0.278,'Electricity': 2.0, 'Diesel': 2.1 },
      }
    }
  })

  formatIrrigationFuels() {
    return Object.keys(this.factors().irrigation.factors).map(key => {
      return {
        value: key,
        label: key,
      }
    })
  }

  formatIrrigationMethods() {
    return Object.keys(this.factors().irrigation.methods).map(key => {
      return {
        value: key,
        label: key,
      }
    })
  }

  formatProducts(climateZone) {
    let products = this.factors(climateZone).fertilisers.products;
    let result = [];
    Object.keys(products).map(key => {
      result.push({
        value: key,
        label: key,
      })
    })
    return result;
  }

  getDryWetCondition(climateZone) {
    if (conditions[climateZone]) {
      return conditions[climateZone]
    }

    return 'unknown'
  }

  getFullDirectFactorName(type) {
    switch (type) {
      case 'synthetic': return 'Synthetic fertiliser (EF1SN)';
      case 'Other': return 'Other N applications (EF1ON)';
      case 'SheepOther': return 'Sheep and ‘other animals’ (EF3PRP, CPP)';
      case 'CattlePoultryPigs': return 'Cattle (dairy, nondairy and buffalo), poultry and pigs (EF3PRP, CPP)';
      default: return 'Other N applications (EF1ON)';
    }
  }

  getDirectFertiliserEmissionFactor(climateZone, type, table) {
    if (type === 'SheepOther') {
      return table.filter(obj => obj.disaggregation === 'all')[0].value;
    }

    try {
      let zone = this.getDryWetCondition(climateZone);
      let fullName = this.getFullDirectFactorName(type);
      console.log(zone);
      console.log(fullName)
      let result = table.filter(obj => obj.emission_factor === fullName && zone === obj.disaggregation)[0].value
      return result;
    } catch (e) {
      console.log(e);
    }

  }

  _calculateFertiliserProduction() {

  }

  _calculateCustomNPK(customNPK, overallP, region, table) {
    try {
      let rg = table.filter(obj => region.indexOf(obj.region) > -1)[0];

      let final = overallP +
        (customNPK.na / 100) * (rg ? rg.amonia : 1) +
        (customNPK.nn / 100) * (rg ? rg.nitric_acid : 1) +
        (customNPK.nu / 100) * (rg ? rg.urea : 1) +
        (customNPK.p / 100) * (rg ? rg.p2o5 : 1) +
        (customNPK.k / 100) * (rg ? rg.k2o : 1)

      console.log(final)
      return final;
    } catch (e) {
      console.log(e)
      return undefined;
    }


  }

  calculateFertiliserEmission(records, climateZone, area) {
    let factors = this.factors(climateZone).fertilisers;

    let total = 0;

    records.map(record => {
      let amount = parseFloat(record.amount) * area;
      let PRODUCTION = parseFloat(amount * factors.products[record.product].efp);

      let amountN = parseFloat(amount) * record.percentageN / 100;
      let amountL = parseFloat(amount) * record.percentageL / 100;
      let amountU = parseFloat(amount) * record.percentageU / 100;

      let DIRECT = amountN * factors.products[record.product].efd * 44 / 28 * factors.GWPN2O;

      let leaching = amountN * factors.LF * factors.EFLeach * 44 / 28 * factors.GWPN2O;
      let volatilization = amountN * factors.EFvol * factors.products[record.product].frac * 44 / 28 * factors.GWPN2O;

      let INDIRECT = leaching + volatilization;

      let liming = amountL * factors.EFlime * 44 / 12;

      let urea = amountU * factors.EFurea * 44 / 12;

      total = total + PRODUCTION + DIRECT + INDIRECT + liming + urea;
    });


    return total;
  }

  calculateResideEmission(type, amountB, amountL, amountN, climateZone, area) {
    let factors = this.factors(climateZone).residues;

    if (type === 'burned') {
      let ch4 = parseFloat(amountB) * area * factors.efCH4;
      let n2o = parseFloat(amountB) * area * factors.efN2O;

      console.log(amountB, area)
      let total = ch4 * factors.GWPCH4 + n2o * factors.GWPN2O;

      return total;
    } else {
      let NResidue = parseFloat(amountL) * area * amountN / 100;
      let total = (((NResidue * factors.EF1) + (NResidue * factors.EF5 * factors.FRACleach)) * (44 / 28)) * factors.GWPN2O;
      return total;
    }
  }

  calculatePesticideEmission(records, area) {
    let total = 0;

    records.map(record => {
      let factors = this.factors().pesticides;
      let emission = record.energy * parseFloat(record.amountP) * area * factors.conversionMJtoCO2
      total = total + emission;
    })
    return total;
  }

  calculateSoilEmission(socChange, ratio, climateZone) {
    let factors = this.factors(climateZone).soil;
    let Nmin = parseFloat(socChange) * ratio;
    let total = ((Nmin * factors.EFmin + Nmin * factors.EFLeach * factors.LF) * (44 / 28)) * factors.GWPN2O;
    return total;
  }

  calculateAnimalsEmission(records, climateZone) {
    let total = 0;
    let factors = this.factors(climateZone).animals;
    records.map(record => {
      let nexcretion = record.category.rate * (record.category.mass / 1000) * 365
      // DIRECT
      let DIRECT = parseFloat(record.numberOfAnimals) * nexcretion * parseFloat(record.hours) / (365 * 24) * factors.EF3 * (44 / 28) * factors.GWPN2O;
      console.log('DIRECT: ', DIRECT);
      // INDIRECT
      let leaching = parseFloat(record.numberOfAnimals) * nexcretion * parseFloat(record.hours) / (365 * 24) * factors.LF * factors.EF5 * (44 / 28) * factors.GWPN2O;
      let volatilization = parseFloat(record.numberOfAnimals) * nexcretion * parseFloat(record.hours) / (365 * 24) * factors.Fvol * factors.EF4 * (44 / 28) * factors.GWPN2O;
      let INDIRECT = leaching + volatilization;
      console.log('INDIRECT: ', INDIRECT);
      // ENTERIC FERMENTATION
      let ENTERIC = parseFloat(record.numberOfAnimals) * record.category.efef * factors.GWPN2O / 1000000;
      console.log('ENTERIC: ', ENTERIC);

      total = total + DIRECT + INDIRECT + ENTERIC;
    })

    return total;
  }

  calculateFuelEmission(direct, estimated, isDirect, area) {
    if (isDirect) {
      let total = 0;
      direct.map(record => {
        total += parseFloat(record.amount) * record.fuel.ef;
      })
      return total;
    } else {
      let total = 0;

      estimated.map(record => {
        let consumption = 0;
        if (record.isOperation) {
          if (record.operationCategory === 'Root crop harvesting') {
            consumption = record.consumption * record.numberOfBales
          } else {
            consumption = record.consumption * area;
          }
        } else {
          consumption = parseFloat(record.hours) * record.engineConsumption;
        }

        let transport = 0;
        if (record.transportLength && record.transportMass) {
          transport = parseFloat(record.transportLength) * (parseFloat(record.transportMass) / 1000) * 0.09;
        }
        console.log('TRANSPORT :', transport);
        total = total + consumption * record.fuel.ef + transport;
      });

      return total;
    }
  }

  calculateIrrigationEmission(records, area) {
    let factors = this.factors().irrigation;

    let total = 0;

    records.map(record => {

      //Za Irrigation je sledeca racunica: 3.500.000 m3 x 0.278 kWh/m³ x 72 g CO2eq/kWh = 70.056.000 g CO2eq = 70.056 kg CO2eq
      // (VOL(m3) * ENERGY USE (kWh/m3) * EF (gCO2eq/kWh))/1000
      
      let emission = (parseFloat(record.volume) * (record.percentage/100) * factors.methods[record.method].energyUse * factors.ef) / 1000;

      total = total + emission;

    })


    return total;
  }

  calculateBiomassReduction(model) {
    let eBiomass = parseFloat(model.amountB) * model.energyContentB;

    let eUsable = eBiomass * (model.efficiency / 100);

    let amountF = eUsable/model.energyContent;

    let eReduction = amountF * model.ef;

    return eReduction;
  }
}

export default new $carbon();